'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBeforeCustomAvailabilityPeriod = isBeforeCustomAvailabilityPeriod;
exports.isDuringCustomAvailabilityPeriod = isDuringCustomAvailabilityPeriod;
exports.isAfterCustomAvailabilityPeriod = isAfterCustomAvailabilityPeriod;
exports.isCustomAvailabilityDurationValid = isCustomAvailabilityDurationValid;
exports.isCustomAvailabilityPeriodValid = isCustomAvailabilityPeriodValid;
exports.isDateInPast = isDateInPast;
exports.validTimeRange = validTimeRange;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _dates = require('MeetingsBase/constants/dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBeforeCustomAvailabilityPeriod(todayUTC, startDate) {
  return startDate && todayUTC.isSameOrBefore(startDate);
}

function isDuringCustomAvailabilityPeriod(todayUTC, startDate, endDate) {
  return startDate && endDate && todayUTC.isAfter(startDate) && todayUTC.isSameOrBefore(endDate);
}

function isAfterCustomAvailabilityPeriod(todayUTC, endDate) {
  return endDate && todayUTC.isAfter(endDate);
}

function isCustomAvailabilityDurationValid(startDate, endDate) {
  // Add one because availability is inclusive of end date
  var daysOfAvailability = _I18n2.default.moment.utc(endDate).diff(_I18n2.default.moment.utc(startDate), 'days') + 1;
  return daysOfAvailability > 0 && daysOfAvailability <= _dates.MAX_CUSTOM_AVAILABILITY_WEEKS * 7 + 1;
}

function isCustomAvailabilityPeriodValid(startDate, endDate) {
  if (!startDate || !endDate) {
    return false;
  }
  return isCustomAvailabilityDurationValid(startDate, endDate);
}

function isDateInPast(date, now, userTimezone) {
  // if the last moment in a day is before now, that day is in the past
  var dateMoment = _I18n2.default.moment.tz(date, userTimezone).endOf('day');
  var nowMoment = _I18n2.default.moment(now);
  return dateMoment.isBefore(nowMoment);
}

function validTimeRange(_ref) {
  var start = _ref.start,
      end = _ref.end;

  var startNotBelowZero = start >= 0;
  var endNotAboveMax = end <= _dates.DAY_DURATION;

  return startNotBelowZero && endNotAboveMax && start < end;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/utils/dates.js
// module id = 187
// module chunks = 0